import type React from "react"
import { ChevronRight } from "react-feather"
import { Link } from "react-router-dom"
import { Spinner } from "@/components/ui/spinner"
import { cn } from "@/lib/utils"

interface ProfileListItemProps extends React.HTMLAttributes<HTMLDivElement | HTMLAnchorElement> {
  icon?: React.ReactNode
  title: string
  url?: string
  disabled?: boolean
  loading?: boolean
  isDestructive?: boolean
  target?: React.HTMLAttributeAnchorTarget
  onClick?: () => void
}

export function ProfileListItem({
  icon,
  title,
  url,
  disabled = false,
  loading = false,
  isDestructive = false,
  onClick,
  className,
  target = "_self",
  ...props
}: ProfileListItemProps) {
  const content = (
    <>
      <div className="flex items-center gap-3 flex-1 rounded-[6px]">
        {loading && <Spinner className="text-slate-500" />}
        {!loading && icon && <div className="text-slate-500">{icon}</div>}
        <span
          className={cn("text-sm font-medium", isDestructive ? "text-red-500" : "text-slate-600")}
        >
          {title}
        </span>
      </div>
      <ChevronRight className="h-5 w-5 text-slate-400" />
    </>
  )

  const baseClassName = cn(
    "flex items-center justify-between p-4 bg-white transition-colors",
    !disabled ? "cursor-pointer hover:bg-slate-50" : "opacity-50 pointer-events-none",
    className
  )

  if (url) {
    return (
      <Link to={url} className={baseClassName} target={target} {...props}>
        {content}
      </Link>
    )
  }

  return (
    <div className={baseClassName} onClick={onClick} {...props}>
      {content}
    </div>
  )
}
